import React from 'react'
import styles from './socialMatchesPanels.module.scss'
import classNames from 'classnames'
import i18n from 'constants/strings'
import { PageUrls as ProfileUrls, SubPaths } from 'components/profile/ProfileRouter/ProfileRouter'
import { RouterBtn } from 'components/generic/router/links'
import Panel from 'components/generic/containers/Panels'

const SubmitScorePanel = () => {
  return (
    <Panel className={classNames(styles.panel, styles.submitScore)} hasShadow as='section'>
      <div className={styles.text}>
        <h2 className={styles.title}>{i18n.t('strSocialMatches.submitAScore.title')}</h2>
        <p>{i18n.t('strSocialMatches.submitAScore.info')}</p>
      </div>
      <RouterBtn
        to={{
          pathname: ProfileUrls.Profile,
          hash: SubPaths.PostScore,
          state: { fromMyScores: true },
        }}
        fullWidthAtMobile
        className={styles.postScoreBtn}
      >
        {i18n.t('strCommonUI.button.postScore')}
      </RouterBtn>
    </Panel>
  )
}

export default SubmitScorePanel
